import { PencilIcon } from '@heroicons/react/24/solid'
import { OfferEntry } from '../../../../../types/Controlling/OfferEntry'
import EntryMask from './EntryMask'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import Modal from '../../../../UI/Modal/Modal'
import props from '../../../../../redux/props'
import { formatEUR, getPrettyDate } from '../../../../../utility'
import useGetOfferEntryName from '../../../../hooks/Controlling/useGetOfferEntryName'

type Props = {
  entry: OfferEntry
  onChange: (entry: OfferEntry) => void
}

const Entry: React.FC<Props> = ({ entry, onChange }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [data, setData] = useState<OfferEntry>({ ...entry })
  const [show, setShow] = useState(false)
  const getOfferEntryName = useGetOfferEntryName()

  const set = (key: keyof OfferEntry) => (value: any) => setData({ ...data, [key]: value })

  const toggle = () => setShow(!show)

  const confirm = () => {
    onChange(data)
    setShow(false)
  }

  return (
    <>
      <div className="py-1 flex gap-1 items-start">
        <div>
          <div>{getOfferEntryName(data)}</div>
          <div className="flex flex-col mt-1">
            <div className="text-sm text-gray">
              {t.controlling.offer.entry.list.sum}
              {formatEUR(data.amount)}
            </div>
            <div className="text-sm text-gray">
              {t.controlling.offer.entry.list.startDate}
              {getPrettyDate(data.scheduledDate)}
            </div>
            <div className="text-sm text-gray">
              {t.controlling.offer.entry.list.alreadyAccepted}
              {data.accepted ? t.controlling.offer.entry.list.alreadyAcceptedYes : t.controlling.offer.entry.list.alreadyAcceptedNo}
            </div>
          </div>
        </div>
        <div
          onClick={toggle}
          className="ml-auto bg-blue border border-blue hover:bg-white group transition-all cursor-pointer py-1 flex justify-center aspect-square w-7"
        >
          <PencilIcon className="stroke-white group-hover:stroke-blue w-5" />
        </div>
      </div>
      <Modal noForm show={show} onConfirm={confirm} onClose={toggle} title={t.controlling.offer.entry.edit.title}>
        <EntryMask data={data} set={set} />
      </Modal>
    </>
  )
}

export default Entry
